export const hillshade = {
	code: 'hillshade',
	url: "https://geoserver.protezionecivile.fvg.it/cachedwms",
	type: "WMS",
	// "visible": false,
	layer_options: {
		"tiled": true,
		"format": "image/png",
		"layers": "rilievi",
		"transparent": true,
		"SRS": "EPSG:3857",
		"VERSION": "1.1.1"
	}
};

export const osm = {
	code: 'osm',
	url: "https://geoserver.protezionecivile.fvg.it/cachedwms",
	type: "WMS",
	// "visible":false,
	layer_options: {
		"tiled": true,
		"format": "image/png",
		"layers": "osm:osm",
		"transparent": true,
		"SRS": "EPSG:3857",
		"VERSION": "1.1.1"
	}
}

export const orto = {
	code: 'orto',
	url: "https://geoserver.protezionecivile.fvg.it/cachedwms?",
	type: "WMS",
	// "visible": false,
	layer_options: {
		"tiled": true,
		"format": "image/png",
		"layers": "data:ortofoto",
		"transparent": true,
		"SRS": "EPSG:3857",
		"VERSION": "1.1.1"
	}
}
